import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../../environments/environment';
import { Apollo } from 'apollo-angular';
import { getActivities, getAdicionales, getFiles, getProyectos, getResponsables } from './querys';
import { firstValueFrom } from 'rxjs';

export class project{
  questionId?: Number;
  allocationId?: Number;
  name?: String;
  description?: String;
  weighing?: Number;
  roleId?: Number;
}

export class activitie{
  projectId?: String;
  name?: String;
  start_date?: String;
  due_date?: String;
  roleId?: Number;
}

export class progress{
  activityId?: String;
  month?: Number;
  year?: Number;
  planned?: Number;
  executed?: Number;
}

export class aditional{
  projectId?: String;
  nombre?: String;
  tipo?: String;
}

export class aditionalActivity{
  activityId?: String;
  additionalId?: Number;
  monto?: String;
  comentario?: String;  
  file?: File;
  date?: String;
}

@Injectable({
  providedIn: 'root'
})

export class ProjectsService {

  private readonly apiUrl = environment.api_cuestionariosA_rest;
  private headers = new HttpHeaders().append('Content-Type', 'application/json')
      .append('Authorization', 'Bearer ' + localStorage.getItem('token'));
  private headersAr = new HttpHeaders().append('enctype', 'multipart/form-data')
    .append('Authorization', 'Bearer ' + localStorage.getItem('token'));

  constructor(
    private readonly http: HttpClient,
    private apollo: Apollo,
  ) {}

  /** Proyectos */
  public async getProjects(){
    const { data } = await firstValueFrom(
      this.apollo.use(environment.api_cuestionarios).watchQuery<any>({
        query: getProyectos,
        context: { headers: this.headers },
        fetchPolicy: 'no-cache',
        variables: {
          args: {
            "relations": {
              "loadRelations": "FULL"
            },
            "pagination": {
              "isUnlimit": true
            }
          }
        },
      }).valueChanges.source
    );
    return data;
  }
  public postProjects(proj){
    const project: project = {
      questionId: proj.questionId,
      allocationId: proj.allocationId ? Number(proj.allocationId) : undefined,
      name: proj.name,
      weighing: proj.weighing?proj.weighing:undefined,
      roleId: proj.responsible?Number(proj.responsible):undefined,
    }
    const body = JSON.stringify(project);
    const url = `${this.apiUrl}projects`;
    return this.http.post(`${url}`, body, {headers: this.headers});
  }
  public patchProjects(proj){
    const project: project = {
      questionId: proj.questionId,
      name: proj.name,
      weighing: proj.weighing?proj.weighing:undefined,
      roleId: proj.responsible?Number(proj.responsible):undefined,
    }
    const body = JSON.stringify(project);
    const url = `${this.apiUrl}projects/${proj.id}`;
    return this.http.patch(`${url}`, body, {headers: this.headers});
  }
  public deleteProject(id){
    const url = `${this.apiUrl}projects/${id}`;
    return this.http.delete(`${url}`, {headers: this.headers});
  }
  /** Actividades */
  public async getActivities(id){
    const { data } = await firstValueFrom(
      this.apollo.use(environment.api_cuestionarios).watchQuery<any>({
        query: getActivities,
        context: { headers: this.headers },
        fetchPolicy: 'no-cache',
        variables: {
          "args": {
            "relations": {
              "loadRelations": "FULL"
            },
            "filter": {
              "operator": "AND",
              "conditions": [
                {
                  "field": "projectId",
                  "operator": "EQUAL",
                  "value": id
                }
              ]
            },
            "pagination": {
              "isUnlimit": true
            }
          }
        },
      }).valueChanges.source
    );
    
    return data.activities;
  }
  public postActivities(act){
    const activitie: activitie = {
      name: act.name,
      projectId: act.idProyect,
      start_date: act.start_date,
      due_date: act.end_date,
      roleId: act.responsible?Number(act.responsible):undefined,
    }
    const body = JSON.stringify(activitie);
    const url = `${this.apiUrl}activities`;
    return this.http.post(`${url}`, body, { headers: this.headers });
  }
  public patchActivities(act){
    const activitie: activitie = {
      name: act.name,
      projectId: act.idProyect,
      start_date: act.start_date,
      due_date: act.end_date,
      roleId: act.responsible?Number(act.responsible):undefined,
    }
    const body = JSON.stringify(activitie);
    const url = `${this.apiUrl}activities/${act.id}`;
    return this.http.patch(`${url}`, body, { headers: this.headers });
  }
  public deleteActivities(id){
    const url = `${this.apiUrl}activities/${id}`;
    return this.http.delete(`${url}`, {headers: this.headers});
  }
  /** Progreso Actividades */
  public postProgress(adic){
    const progress: progress = {
      year: adic.year,
      month: adic.month,
      planned: adic.planned,
      executed: adic.executed,
      activityId: adic.activitieId, 
    }
    const body = JSON.stringify(progress);
    const url = `${this.apiUrl.split('v1')[0]}progress`;
    return this.http.post(`${url}`, body, { headers: this.headers });
  }
  public patchProgress(adic){
    const progress: progress = {
      year: adic.year,
      month: adic.month,
      planned: adic.planned,
      executed: adic.executed,
    }
    const body = JSON.stringify(progress);
    const url = `${this.apiUrl.split('v1')[0]}progress/${adic.id}`;
    return this.http.patch(`${url}`, body, { headers: this.headers });
  }
  public deleteProgress(id){
    const url = `${this.apiUrl.split('v1')[0]}progress/${id}`;
    return this.http.delete(`${url}`, {headers: this.headers});
  }
  /** Adicionales */
  public async getAditionals(id){
    const { data } = await firstValueFrom(
      this.apollo.use(environment.api_cuestionarios).watchQuery<any>({
        query: getAdicionales,
        context: { headers: this.headers },
        fetchPolicy: 'no-cache',
        variables: {
          projectId: id
        },
      }).valueChanges.source
    );
    return data.aditionalsByProject;
  }
  public postAditional(aditional){
    const adicional: aditional = {
      ...aditional,
    }
    const body = JSON.stringify(adicional);
    const url = `${this.apiUrl}aditionals`;
    return this.http.post(`${url}`, body, { headers: this.headers});
  }
  public patchAditional(aditional){
    const adicional: aditional = {
      nombre: aditional.nombre,
    }
    const body = JSON.stringify(adicional);
    const url = `${this.apiUrl}aditionals/${aditional.id}`;
    return this.http.patch(`${url}`, body, { headers: this.headers});
  }
  public deleteAditional(aditional){
    const url = `${this.apiUrl}aditionals/${aditional.id}`;
    return this.http.delete(`${url}`, { headers: this.headers});
  }
  /** Adicionales actividad */
  public postAditionalActivity(aditional){
    const formData: FormData = new FormData();
    formData.append('activityId', aditional.activityId);
    formData.append('additionalId', aditional.additionalId);
    if(aditional.monto){
      formData.append('monto', aditional.monto);
    }
    if(aditional.comentario){
      formData.append('comentario', aditional.comentario);
    }
    if(aditional.file){
      formData.append('file', aditional.file);
    }
    formData.append('date', aditional.date);
    
    const url = `${this.apiUrl}activity-additionals`;
    return this.http.post(`${url}`, formData, { headers: this.headersAr});
  }
  public patchAditionalActivityComentario(aditional, comentario){
    const adicional = {
      comentario: comentario.comentario,
    }
    const body = JSON.stringify(adicional);
    const url = `${this.apiUrl}activity-additionals/${aditional.id}/comments/${comentario.id}`;
    return this.http.patch(`${url}`, body, { headers: this.headers});
  }
  public async getFile(s3key: string){
    const { data } = await firstValueFrom(
      this.apollo.use(environment.api_cuestionarios).watchQuery<any>({
        query: getFiles,
        context: { headers: this.headers },
        fetchPolicy: 'no-cache',
        variables: {
          "s3Key": s3key
        },
      }).valueChanges.source
    );
    return data.getFilePresignedUrl;
  }
  public deleteFile(aditional, file){
    const url = `${this.apiUrl}activity-additionals/${aditional.id}/files/${file.id}`;
    return this.http.delete(`${url}`, { headers: this.headers});
  }
  /** Responsables */
  public async getResponsables(id: string){
    const { data } = await firstValueFrom(
      this.apollo.use(environment.api_cuestionarios).watchQuery<any>({
        query: getResponsables,
        context: { headers: this.headers },
        fetchPolicy: 'no-cache',
        variables: {
          institutionId: id
        },
      }).valueChanges.source
    );
    return data.rolesByInstitution;
  }
}
